module.exports = __webpack_public_path__ + "static/img/icon_tree.e19505fb.svg";